import { Component, Input } from '@angular/core';
import { Address } from 'odq-toolbox';

@Component({
    selector: 'odq-address-displayer',
    templateUrl: './address-displayer.component.html',
    styleUrls: ['./address-displayer.component.scss'],
    standalone: false
})
export class AddressDisplayerComponent {

  @Input()
  address:Address

  @Input()
  addressLabel:string

  @Input()
  cityLabel:string;

  @Input()
  showPostalCode: boolean = true;

  constructor() { }

  isCityOnly(){
    return !this.address.line1 && !this.address.line2 && !!this.address.city
  }

  buildDisplayablePostalCode(address: Address){
    return address.postalCode ? address.postalCode.substring(0, 3).concat(' ').concat(address.postalCode.substring(3, 7)) : '';
  }

}
